/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Photo_Wrong_TypeInputs */



/**
* | output |
* | --- |
* | "Choose a JPG, PNG or WebP file." |
*
* @param {Settings_Photo_Wrong_TypeInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_photo_wrong_type = /** @type {((inputs?: Settings_Photo_Wrong_TypeInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Photo_Wrong_TypeInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Kies een JPG-, PNG- of WebP-bestand.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez un fichier JPG, PNG ou WebP.")
	return /** @type {LocalizedString} */ ("Choose a JPG, PNG or WebP file.")
});